import { createContext } from 'react';

export const FirebaseContext = createContext(null)
